export enum LocalNotificationStatus {
  NEW = 'NEW',
  DISMISSED = 'DISMISSED',
}
